/**
 * Endpoints for API requests.
 */
export const Endpoints = {
  documents: "api/forms/",
  validateFile: "api/forms/validate/",
  customQuestionDocuments: "api/forms/custom-question/",
  presignedUrl: "api/forms/aws/s3/",
  deleteDocument: "api/forms/archive/", // DELETE api/forms/archive/<document_id>/
  documentPresignedUrl: "api/forms/", // GET api/forms/<document_id>/presigned-url/
  clientExport: "api/forms/export/",
  clientExportStatus: "api/forms/export/status/",
  clients: {
    root: "api/clients/",
    docsToUpload: "api/clients/docstoupload/",
    search: "api/clients/search/",
  },
  taxYears: "api/accounts/tax-years/",
  secureInfo: "api/secured/ssn/",
  spouseInfo: "api/secured/spouseinfo/",
  dependentInfo: "api/secured/dependentInfo/",
  owner: "api/owners/",
  businessLogo: "api/owners/logo/",
  personalInfo: "api/personalInfo/",
  email: {
    email: "/api/email/",
    openAi: "/api/email/send-openai/",
  },
  authentication: {
    login: "api/auth/token/",
    tokenCheck: "api/auth/token/check/",
    refresh: "api/auth/token/refresh/",
    logout: "api/auth/logout/",
    changePassword: "api/auth/changepassword/",
    resetPassword: "api/auth/resetpassword/",
    updatePassword: "api/auth/resetpassword/confirm/",
    verifyEmail: "api/auth/verify-email/",
    resendEmail: "api/auth/resend-verify-email/",
    check: "api/auth/check/",
  },
  user: "/api/users/",
  notification: "/api/notify/",
  bulkUpload: "api/bulk/",
  resendEmail: "api/stripe/management/email",
  notificationSetting: "/api/notify/settings/",
  analytics: "api/analytics/taxpro/",
  billing: "api/stripe/management/billing/",
  subscriptionInfo: "api/stripe/management/subscription-info/",
  failedInvoice: "api/stripe/management/failed-invoice/",
  paymentUpdateCreateSetupIntent:
    "api/stripe/management/payment-update/create-setup-intent/",
  contractUpgradeCreateSetupIntent:
    "api/stripe/management/contracts/upgrade/create-setup-intent/",
  customContractOfferStatus:
    "api/stripe/management/contracts/custom-offer/status/",
  customContractOfferSign: "api/stripe/management/contracts/custom-offer/sign/",
  customContractOfferInviteStatus:
    "api/stripe/management/contracts/custom-offer/invite/status/",
  customContractOfferInviteComplete:
    "api/stripe/management/contracts/custom-offer/invite/complete/",
  contractCommitmentStatus:
    "api/stripe/management/contracts/commitment/status/",
  updatePayment: "api/stripe/management/update-payment/",
  emailTemplates: "api/email/templates/",
  members: "api/management/members/",
  assignment: "api/management/assignments/",
  organizer: "/api/forms/organizer/",
  additionalQuestions: "/api/business/questions/",
  jobs: {
    status: "api/jobs/status",
    result: "api/jobs/result",
  },
  engagement: "/api/engagement/",
  summary: "api/notify/summary/",
  products: "api/products/packages/",
  branding: "/branding/",
  onboarding: {
    complete: "api/onboarding/complete/",
    liteComplete: "api/onboarding/lite/complete/",
    intercomJwt: "api/onboarding/intercom-jwt/",
    intercomContext: "api/onboarding/intercom-context/",
  },
  admin: {
    returnDebug: "api/ext/admin/returns/:returnId/debug/",
    timestepDetail: "api/ext/admin/returns/:returnId/timesteps/:timestepId/",
    clearState: "api/ext/admin/returns/:returnId/clear-state/",
    clearCache: "api/ext/admin/returns/:returnId/clear-cache/",
    clearLogs: "api/ext/admin/returns/:returnId/clear-logs/",
    clearAll: "api/ext/admin/returns/:returnId/clear-all/",
    integrationLogs: "api/ext/admin/integrations/logs/:userId/",
    analytics: "api/analytics/oneclick/",
  },
  jotform: {
    session: "api/integrations/jotform/session/",
  },
  cognito: {
    session: "api/integrations/cognito/session/",
  },
  ghl: {
    session: "api/integrations/ghl/session/",
  },
  suitedash: {
    session: "api/integrations/suitedash/session/",
  },
  extensionSettings: "api/ext/settings/",
  clientArchive: "api/ext/client-archive/",
  supportedForms: "api/ext/supported-forms/",
  featureFlags: "api/feature-flag/user-flags/",
  referrals: {
    // Public endpoints (no auth required)
    validate: "api/referrals/validate/",
    example: "api/referrals/example/",
    // Onboarding endpoints (auth required)
    onboardingStatus: "api/referrals/onboarding/status/",
    publicBusinesses: "api/referrals/onboarding/public-businesses/",
    associate: "api/referrals/onboarding/associate/",
    source: "api/referrals/onboarding/source/",
    // Dashboard endpoints (auth required)
    dashboard: "api/referrals/dashboard/",
    export: "api/referrals/export/",
    link: "api/referrals/link/",
    slug: "api/referrals/slug/",
    slugCheck: "api/referrals/slug/check/",
    branding: "api/referrals/branding/",
    rewardLink: "api/referrals/rewards/:rewardDbId/link/",
  },
  tags: "api/tags/",
  clientTags: "api/ext/client-tags/",
  support: {
    debugSession: "api/support/debug-session/",
    debugSessionDetail: "api/support/debug-session/:sessionId/",
  },
  serviceBureau: {
    businesses: "api/service-bureau/businesses/",
    businessMembers: "api/service-bureau/businesses/:businessId/members/",
    loginAs: "api/service-bureau/businesses/:businessId/login-as/:userId/",
    // Managed-business onboarding flow. Service-bureau-created businesses
    // receive a unique invite link with a JWT token; the user clicks
    // through, sets a password, and is auto-authenticated.
    managedBusinessInviteStatus:
      "api/service-bureau/managed-business/invite/status/",
    managedBusinessInviteComplete:
      "api/service-bureau/managed-business/invite/complete/",
    // Managed-business contract endpoints used by the onboarding shell
    // after invite completion. Pricing is fixed by the bureau; the
    // client never supplies a unit price.
    managedBusinessContractStatus:
      "api/service-bureau/managed-business/contract/status/",
    managedBusinessContractDraft:
      "api/service-bureau/managed-business/contract/draft/",
    managedBusinessContractSign:
      "api/service-bureau/managed-business/contract/sign/",
  },
};
